export function getEnumValues<T>(enumType: { [key: string]: T }): T[] {
  return Object.keys(enumType).map((key: string) => enumType[key]);
}
